import React from 'react';

const FteConfigurationComponentLoadable = React.lazy(() => import('./FteConfigurationComponent'));

export {
    FteConfigurationComponentLoadable
};
